import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export const useFarmerId = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const [farmerId, setFarmerId] = useState<string | null>(null);

  useEffect(() => {
    // ورود به داشبورد کشاورز از پنل همکاران
    const searchParamsFarmerId = searchParams.get("farmerId");
    const searchParamsToken = searchParams.get("token");
    if (searchParamsToken) {
      localStorage.setItem("token", `Bearer ${searchParamsToken}`);
    }
    // تغییر نقش در صفحه پیشخوان
    const locationStateFarmerId = location?.state?.farmerId;
    //
    const localStorageFarmerId = localStorage.getItem("profile")
      ? JSON.parse(localStorage.getItem("profile")!)?.id
      : null;
      
    if (
      searchParamsFarmerId ||
      locationStateFarmerId ||
      localStorageFarmerId
    ) {
      setFarmerId(
        searchParamsFarmerId ||
          locationStateFarmerId ||
          localStorageFarmerId
      );
    } else {
      navigate("/login");
    }
  }, []);

  return [farmerId];
};
